/**
 * Safely runs code meant for browser environments only.
 */
export function safelyRunOnBrowser(callback) {
  if (typeof window !== 'undefined') {
    return callback({
      window: window
    });
  }
  return undefined;
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-shared/dist/esm/safelyRunOnBrowser.js
// module id = 71
// module chunks = 0